const INR_TO_BDT = 1.42;
const BD_MARKUP = 1.4;

const detectBangladesh = () => {
    try {
        const region = new URLSearchParams(window.location.search).get("region");
        if (region) return region.toLowerCase() === "bd";
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
        return tz === "Asia/Dhaka" || langs.some((l) => /-BD$/i.test(l || ""));
    } catch {
        return false;
    }
};

export const isBangladesh = detectBangladesh();

export const toBDT = (inr) => Math.round(inr * INR_TO_BDT * BD_MARKUP);

const INR_TO_EUR = 0.011;

export const formatPrice = (inr, lang, aed = null) => {
    if (lang === "ar") return aed != null ? `AED ${aed}` : `AED ${(inr * 0.044).toFixed(1)}`;
    if (lang === "fr") return `€${(inr * INR_TO_EUR).toFixed(2)}`;
    if (lang === "bn" && isBangladesh) return `৳${toBDT(inr)}`;
    return `₹${inr}`;
};

export const cartTotal = (items, lang) => {
    const inr = items.reduce((s, i) => s + i.price * i.qty, 0);
    if (lang === "ar" && items.length > 0 && items.every((i) => i.aed != null)) {
        return `AED ${items.reduce((s, i) => s + i.aed * i.qty, 0)}`;
    }
    return formatPrice(inr, lang);
};
